import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=159bcc82&scoped=true&"
import script from "./DepartmentList.vue?vue&type=script&lang=js&"
export * from "./DepartmentList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DepartmentList.vue?vue&type=style&index=1&id=159bcc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159bcc82",
  null
  
)

export default component.exports